import { createModel } from "@rematch/core";
import type { RootModel } from ".";
import {UserActivityTypes} from "../types/user-activity.types";

export interface UserActivityStoreProps {
    activeUserRecords: UserActivityTypes.ActiveUserData[];
    weeklyActiveUserRecords: UserActivityTypes.WeeklyActivityData;
    loading: {
        fetchActiveUserData: boolean;
        fetchWeeklyActiveData: boolean;
        fetchTeamUserActivityRecords: boolean;
        fetchTeamUserWeeklyActivityRecords: boolean;
    };
    teamUserActivityRecords : UserActivityTypes.TeamUserActivityData[];
    teamUserWeeklyActivityRecords : UserActivityTypes.TeamUserWeeklyActivityRecords[];
}

export const userActivityInitialState: UserActivityStoreProps = {
    activeUserRecords: [],
    teamUserActivityRecords: [],
    teamUserWeeklyActivityRecords: [],
    weeklyActiveUserRecords: {},
    loading: {
        fetchActiveUserData: false,
        fetchWeeklyActiveData: false,
        fetchTeamUserActivityRecords: false,
        fetchTeamUserWeeklyActivityRecords: false
    },
};

export const userActivity = createModel<RootModel>()({
    state: userActivityInitialState,
    reducers: {
        toggleLoading: (store, prop: keyof UserActivityStoreProps["loading"], v: boolean) => ({
            ...store,
            loading: {
                ...store.loading,
                [prop]: v,
            },
        }),
        setActiveUserRecords: (state, items: any) => ({
            ...state,
            activeUserRecords : items,
        }),
        setWeeklyActiveUserRecords: (state, items: any) => ({
            ...state,
            weeklyActiveUserRecords : items,
        }),
        setTeamUserRecords: (state, items: any) => ({
            ...state,
            teamUserActivityRecords : items,
        }),
        setWeeklyTeamUserRecords: (state, items: any) => ({
            ...state,
            teamUserWeeklyActivityRecords : items,
        }),
    },
});
